import { BaseModel, fillOwnProperties, registerModel } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'

export default class ResearchDemandApplication extends BaseModel {
  static override constructorName = 'ResearchDemandApplication'

  fio: string = ''
  'company_name': string = ''
  phone: string = ''
  email: string = ''
  comments: string = ''
  'terms_accepted': boolean = false
  'privacy_accepted': boolean = false
  status: string = ''

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data)
    }
  }
}

registerModel(ResearchDemandApplication)
